// Single source of truth for event/notification priority across the app.
//
// An event is created with one of these four priorities, and the priority is
// copied onto every notification that event raises (see the API's
// event.service.js -> notification.service.js). Both the notification bell and
// the notification panel colour-code by it, so the values and colours have to
// agree everywhere — hence this module rather than a local copy per component.

export const PRIORITY_NOT_SET = "Not set";

export const PRIORITIES = ["High", "Medium", "Low", PRIORITY_NOT_SET];

// `color` is the accent (dot, left border, icon, badge text); `bg` is the soft
// tint behind it. Deliberately distinct hues rather than shades of one colour
// so the level reads at a glance.
const PRIORITY_META = {
  High: { label: "High", color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
  Medium: { label: "Medium", color: "#f59e0b", bg: "#fffbeb", border: "#fde68a" },
  Low: { label: "Low", color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  [PRIORITY_NOT_SET]: { label: "Not set", color: "#6b7280", bg: "#f9fafb", border: "#e5e7eb" },
};

// Records saved before priorities existed have no priority at all, and older
// clients may send a differently-cased value — both settle on "Not set".
export const normalizePriority = (value) =>
  PRIORITIES.find((p) => p.toLowerCase() === String(value || "").trim().toLowerCase()) ||
  PRIORITY_NOT_SET;

export const getPriorityMeta = (value) => PRIORITY_META[normalizePriority(value)];

// Highest first, so a list can be sorted by urgency when that's wanted.
const PRIORITY_RANK = { High: 0, Medium: 1, Low: 2, [PRIORITY_NOT_SET]: 3 };
export const getPriorityRank = (value) => PRIORITY_RANK[normalizePriority(value)];

// react-select options for the event forms.
export const priorityOptions = PRIORITIES.map((value) => ({
  value,
  label: PRIORITY_META[value].label,
}));
